import React from 'react'
import ReactDOM from 'react-dom'

export const onInitialClientRender = async () => {
  if (process.env.NODE_ENV === 'development') {
    const { default: axe } = await import('@axe-core/react')
    await axe(React, ReactDOM, 1000, {})
  }
}
